import React from 'react';

const Payslips = () => {
  return (
    <div className="p-4">
      <h2 className="text-xl font-semibold">Payslips</h2>
      <p className="text-sm text-gray-600">Payslip generation and review views will be added here.</p>
    </div>
  );
};

export default Payslips;
